import React from "react";
import "./LocationSection.css";

const LocationSection = () => {
  return (
    <section className="location-section" id="location-map">
      <div className="container">
        <div className="location-layout">
          {/* Left Content */}
          <div className="location-content">
            <div className="location-header">
              <h2 className="location-title">
                Location <span className="highlight">Advantages</span>
              </h2>
            </div>

            {/* Google Maps */}
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28080.429067518555!2d77.058303!3d28.387448!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19a8ffffffff%3A0xc2a99f416c9b87d1!2sAnsal%20Api%20Esencia!5e0!3m2!1sen!2sin!4v1757582049567!5m2!1sen!2sin"
                width="100%"
                // height removed; CSS will size via aspect-ratio
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ansal Esencia Location Map"
                className="location-map"
              />
            </div>

            {/* Buying Information */}
            <div className="buying-info">
              <div className="buying-header">
                <h2 className="buying-title">
                  Buy Floor in{" "}
                  <span className="highlight">Ansal Esencia Gurgaon</span>
                </h2>
              </div>

              <div className="buying-description">
                <p>
                  Buy floor in Ansal Esencia Gurgaon, Sector 67, Gurgaon. Our
                  Property Advisors can assist with location, amenities, floor
                  plan, price, resale price, payment plan, schedule, delivery
                  date, brochure, additional charges, application form, and
                  reviews. Also available: floors on rent in Ansal Esencia.
                  Nearby localities include Orchid Island, Woodstock Floors,
                  Sushant Lok, and HUDA sectors. Call our property expert now
                  +91 9999063322 for best deals on floors in Gurgaon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
